module.exports = __webpack_public_path__ + "../resources/images/illustration_flagged-2e1d7ab8ecc0d01b9f9b78568b882e09.svg";